module.exports = __webpack_public_path__ + "static/2_3_game-tree-1_EL-7d444bd8ecc45038c7228dc12c18fa4b.svg";